import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import { ProfileMenu } from "@/ui";
import { isTreezSSOEnabled, useAuth } from "auth";
import { userMenu } from "../../../../config/layout/header";
import routes from "../../../../config/routes/routes";
import useMeta from "../../../hooks/useMeta.js";
import usePermissions from "../../../hooks/auth/usePermissions";

const { SING_OUT } = routes;

const UserMenu = () => {
    const history = useHistory();
    const { user } = useMeta();
    const isAllow = usePermissions();
    const { logout } = useAuth();

    const email = user?.email ? String(user.email).trim() : "";
    const localPart = email.includes("@") ? email.split("@")[0] : email;
    const displayName = localPart || "User";
    const disabled = Boolean(user?.loading) || !email;

    const items = useMemo(
        () =>
            userMenu
                .filter(entry => isAllow(entry.permissions))
                .map(entry => ({
                    id: entry.route,
                    label: entry.label,
                    icon: entry.icon,
                    onSelect: () => history.push(entry.route),
                })),
        [history, user],
    );

    const handleSignOut = () => {
        if (isTreezSSOEnabled) {
            logout();
            return;
        }
        Auth.signOut();
    };

    return (
        <ProfileMenu
            aria-label={
                email ? `Account menu, ${email}` : "Account menu, loading"
            }
            avatarColorSeed={email || user?.id || "user"}
            disabled={disabled}
            items={items}
            onSignOut={handleSignOut}
            signOutLabel={SING_OUT.label}
            userName={displayName}
        />
    );
};

export default UserMenu;
